/**
 * 每日用户活跃统计组件
 * zxw
 * 2024-01-17
 */
import React, { useEffect, useState } from 'react';
import { Chart } from '@antv/g2';
import CNF from '../../incs/Config.js';

const UserUTACD = (props) => {
    const [data, setData] = useState([]);

    useEffect(()=>{
        if (props.data) setData(props.data);
    },[props]);

    useEffect(()=>{
        const chart = new Chart({
            container: props.container ? props.container : 'antv-g2-id',
            autoFit: props.isMobileDevice ? true : false,
        });

        chart.title({
            title: '每日用户活跃统计',
            subtitle: '展示180天内每日登录人数和登录次数。',
        });

        chart.data(data);
          
        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('color', 'type')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches.default,
            })
            .axis('x', { title: '日期', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            .animate('enter', {
                type: 'pathIn',
                duration: 3000,
            },)
            .tooltip({
                items: [
                    (d) => {
                        if (d.type === '登录人数') {
                            return { channel: 'y', value: `${d.count}个`, }
                        } else {
                            return { channel: 'y', value: `${d.count}次`, }
                        }
                    },
                ],
            })
            .style('lineWidth', 1);
        chart.render();

        return ()=>{
            chart.destroy();
        }
    },[data]);

    return <div id='antv-g2-id'></div>;
}

export default UserUTACD;